module.exports = __webpack_public_path__ + "img/personal_faq_reply_grey.a4bcd628.svg";